export const shsToolbarStyles = {
    '&.MuiToolbar-root': {
        background: 'transparent',
        padding: 0,
        margin: '5px 0 25px',
        width: '100%'
    }
};
